<template>
	<div class="home">
		<a-breadcrumb>
			<a-breadcrumb-item href="">
				<a-icon type="home" />
			</a-breadcrumb-item>
			<a-breadcrumb-item href="">
				<a-icon type="user" />
				<span>用户信息</span>
			</a-breadcrumb-item>
			<a-breadcrumb-item> 用户管理 </a-breadcrumb-item>
		</a-breadcrumb>

		<div class="search-list-box">
			<a-form  class="ant-advanced-search-form">
				<a-row :gutter="24">
					
					<a-col :span="8">
						<a-form-item :label="`提交时间：`">
							<a-range-picker  :disabledDate="disabledDate" :ranges="{ '今天': [moment(), moment()] }" @change="handleChangeDate" :key="pickerKey" style="width: 120px" format="YYYY-MM-DD" />
						</a-form-item>
					</a-col>

					<a-col :span="6" :style="{
              textAlign: 'left',
              paddingLeft: '25px',
              marginTop: '6px',
            }">
						<a-button type="primary" @click="getList"> 查询 </a-button>
						<a-button :style="{ marginLeft: '8px' }" @click="handleReset">
							重置
						</a-button>
					</a-col>
				</a-row>
			</a-form>
			<div class="search-result-list">

				<div class="table-header-box">
					<div class="left">
						<h3 class="title">用户信息列表</h3>
					</div>
					<div class="right">
						<a-button type="primary" class="marginr20" @click="showDetail">
							详情
						</a-button>
						<a-button type="primary" class="marginr20" @click="deleteUser">
							删除
						</a-button>
					</div>
				</div>
				<a-table :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }" :columns="columns"  @change="handleTableChange" :pagination="{total: total_page * 10}"
				 :data-source="list" rowKey="user_id" size="small">
				<span slot="date" slot-scope="date, info">
					{{info.province}}  {{info.city}}
				</span>
				</a-table>
			</div>
		</div>


		<a-modal v-model="detailShow" title="详细信息" :footer="null">
			<a-spin :spinning="detailLoading">
				<a-form :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }" style="margin: 0 auto; width: 100%">
					<a-form-item label="登录账号：" >
						<a-input v-model="info.user_name" :disabled="true"/>
					</a-form-item>
					<a-form-item label="用户姓名：">
						<a-input v-model="info.real_name" :disabled="true"/>
					</a-form-item>
					<a-form-item label="手机号码：">
						<a-input v-model="info.mobile" :disabled="true"/>
					</a-form-item>
					<a-form-item label="省市：">
						<a-input v-model="info.province + info.city"  :disabled="true"/>
					</a-form-item>
					<a-form-item label="地址：">
						<a-input v-model="info.address" :disabled="true"/>
					</a-form-item>
					<a-form-item label="注册时间：">
						<a-input v-model="info.add_time" :disabled="true"/>
					</a-form-item>
				</a-form>
				<div class="model-footer">
					<div class="left">
						<a-button type="primary" class="marginr20" html-type="submit" @click="detailShow = false">
							取消
						</a-button>
					</div>
					<div class="right">
						<a-button type="dashed"  :disabled="isEditBtn('prev')" @click="editToData('prev')"  class="" html-type="submit">
							上一条
						</a-button>
						<a-button type="dashed"  :disabled="isEditBtn('next')" @click="editToData('next')"  class="marginr20" html-type="submit">
							下一条
						</a-button>
					</div>
				</div>
			</a-spin>
		</a-modal>

	</div>
</template>

<script>
	import moment from 'moment';
	import http from '../http'

	const columns = [
		{
			title: "登录账号",
			dataIndex: "nike_name",
			key: "32"
		},
		{
			title: "用户姓名",
			dataIndex: "real_name",
			key: "132",
			align: 'center'
		},
		{
			title: "手机号码",
			dataIndex: "mobile",
			key: "131",
			align: 'center'
		},
		{
			title: "类型",
			dataIndex: "user_type",
			key: "2"
		},
		{
			title: "省市",
			dataIndex: "province",
			key: "133",
			align: 'center',
			scopedSlots: {
				customRender: 'date'
			},
		},
		{
			title: "详细地址",
			dataIndex: "address",
			key: "12",
		},
		{
			title: "注册时间",
			dataIndex: "add_time",
			key: "124"
		},

	];
	export default {
		data() {
			return {
				expand: false,
				columns,

				detailShow: false,
				
				info: {
					user: {}
				},
				
				searchData: {
					page: 1,
					user_type: 0,
					status: 0,
					start_date: '',
					end_date: ''
				},
				list: [],
				total_page: 0,

				// 表格选择的数据, 存储的是id
				selectedRowKeys: [],
				// 存储的是数据
				selectedRowDataList: [],
				// 当前是第几条编辑信息
				editIndex: 0,

				detailLoading: false,
				pickerKey: Math.random()
			};
		},
		mounted() {
			this.getList()
		},
		methods: {
			moment,
			disabledDate(current) {
			     return current && current >= moment().subtract("days"); //当天之前的不可选，不包括当天
			   //return current && current < moment().endOf(‘day’);当天之前的不可选，包括当天
			},
			handleReset() {
				this.pickerKey = Math.random()
				this.searchData = {
					page: 1,
					user_type: 0,
					status: 0,
					start_date: '',
					end_date: ''
				}
				this.getList();
			},

			handleSelectChange(value) {
				console.log(value);
				this.form.setFieldsValue({
					note: `Hi, ${value === 'male' ? 'man' : 'lady'}!`,
				});
			},
			// 认证通过 
			tocheck () {
				// 判断是否已经选择数据
				if (this.selectedRowKeys.length == 0) {
					this.$message.warning('请先选择角色');
					return
				}
				this.$confirm({
					title: '是否认证审核选中用户?',
					okText: '确定',
					okType: 'danger',
					cancelText: '取消',
					onOk : () => {
						let selectDatas = this.selectedRowKeys
						http({
							method: 'post',
							url: '/api.user.tocheck/',
							data: {
								user_id: selectDatas.join(),
								status: 1
							}
						}).then((res) => {
							if (res.code == '200') {
								this.$message.success('用户认证审核成功');
								this.getList()
							} else {
								this.$message.error(res.data);
							}
						})
					}
				});
			},
			//删除
			deleteUser() {
				// 判断是否已经选择数据
				if (this.selectedRowKeys.length == 0) {
					this.$message.warning('请先选择用户');
					return
				}
				this.$confirm({
					title: '是否删除选中用户?',
					okText: '确定',
					okType: 'danger',
					cancelText: '取消',
					onOk : () => {
						let selectDatas = this.selectedRowKeys
						http({
							method: 'post',
							url: '/api.user.del/',
							data: {
								user_id: selectDatas.join(),
							}
						}).then((res) => {
							if (res.code == '200') {
								this.$message.success('删除用户成功');
								this.getList()
							} else {
								this.$message.error(res.data);
							}
						})
					}
				});
			},
			// 表格分页
			handleTableChange (pagination, filters, sorter) {
				console.log(pagination, filters, sorter)
				this.searchData.page = pagination.current
				this.getList();
			},
			// 表格选择
			onSelectChange(selectedRowKeys) {
				console.log('selectedRowKeys changed: ', selectedRowKeys);
				this.selectedRowKeys = selectedRowKeys;
			},
			// 列表
			getList() {
				http({
					method: 'post',
					url: '/api.user.list/',
					data: this.searchData
				}).then((res) => {
					this.list = res.data.list
					this.total_page = res.data.total_page
				})
			},
			// 日期解析
			handleChangeDate(date) {
				this.searchData.start_date = this.moment(date[0]).format('YYYY-MM-DD')
				this.searchData.end_date = this.moment(date[1]).format('YYYY-MM-DD')
			},
			
			showDetail() {
				// 判断是否已经选择数据
				if (this.selectedRowKeys.length == 0) {
					this.$message.warning('请先选择预约');
					return
				}
				console.log(this.selectedRowKeys)
				let selectDatas = []
				this.list.forEach((v) => {
					if (this.selectedRowKeys.includes(v.user_id)) {
						selectDatas.push(v)
					}
				})
				this.selectedRowDataList = JSON.parse(JSON.stringify(selectDatas))
				console.log(this.selectedRowDataList)
				this.editIndex = 0
				// 获取文章详情
				this.getDetail()
				this.detailShow = true
			},
			// 详情
			getDetail() {
				this.detailLoading = true
				http({
					method: 'post',
					url: '/api.user.detail/',
					data: {
						user_id: this.selectedRowDataList[this.editIndex].user_id
					}
				}).then((res) => {
					this.info = res.data
					this.detailLoading = false
				})
			},
			// 点击上一条 或者 下一条、
			editToData(type) {
				let index = -1
				if (type == 'prev') {
					index = this.editIndex - 1
					if (index == 0) {
						index = 0
					}
				} else if (type == 'next') {
					index = this.editIndex + 1
				}
				this.editIndex = index
				this.getDetail()
			},
			// 判断是否可以点击上一条 或者 下一条、
			isEditBtn(type) {
				if (type == 'prev') {
					if (this.editIndex == 0) {
						return true
					}
					if (this.selectedRowDataList == 1) {
						return true
					}
					if (this.editIndex >= 1) {
						return false
					}
				} else if (type == 'next') {
					if ((this.selectedRowDataList.length - 1) == this.editIndex) {
						return true
					}
				}
			},
		},
	};
</script>
<style>
	.ant-advanced-search-form {
		padding: 24px;
		background: #fbfbfb;
		border: 1px solid #d9d9d9;
		border-radius: 6px;
	}

	.ant-advanced-search-form .ant-form-item {
		display: flex;
	}

	.ant-advanced-search-form .ant-form-item-control-wrapper {
		flex: 1;
	}

	.search-list-box .ant-form {
		max-width: none;
	}

	.search-list-box .search-result-list {
		margin-top: 16px;
		border: 1px dashed #e9e9e9;
		border-radius: 6px;
		background-color: #fafafa;
		min-height: 200px;
		text-align: center;
		padding-top: 80px;
	}
	
	.imgs {
		display: flex;
	}
	.imgs img {
		width: 140px;
		height: 200px;
	}
</style>
